import React, { useState } from "react";
import { FormProvider } from "../components/context/Form/FormContext";
import ConsultForm from "../components/Consult/ConsultForm";
import Sidebar from "../components/Sidebar/Sidebar";

export default function ConsultPage() {

  return (
    <div
      className="d-flex"
      style={{ minHeight: "100vh", backgroundColor: "#000" }}
    >
      <Sidebar />

      <div
        className="flex-grow-1 p-4"
        style={{
          backgroundColor: "#ffffff",
          borderTopLeftRadius: "40px",
          borderBottomLeftRadius: "40px",
          padding: "32px",
          boxShadow: "0 0 12px rgba(0,0,0,0.05)",
        }}
      >
        <h1
          style={{
            color: "#78E01D",
            fontWeight: "600",
            fontSize: "36px",
            marginBottom: "24px",
          }}
        >
          Solicitar pesquisa
        </h1>
        <p style={{ fontSize: "16px", marginBottom: "24px", color: "#555" }}>
          Carregue um documento (PDF) e, em seguida, selecione o produto
          desejado. Após a seleção, clique em <strong>“Enviar”</strong>. O
          sistema irá extrair automaticamente o CNPJ e os dados dos sócios do
          documento para verificar a situação cadastral. Caso o CNPJ esteja
          regular, campos adicionais com as informações dos sócios serão
          exibidos para validação individual.
        </p>

        <div className="App" style={{ marginTop: "38px" }}>
          <div>
            <div>
              <FormProvider>
                <div className="">
                  <ConsultForm />
                </div>
              </FormProvider>
            </div>
          </div>
        </div>{" "}
      </div>
    </div>
  );
}
